export var UPDATE_PROFILE_INFO = 'UPDATE_PROFILE_INFO';
export var SUCCESS_UPDATE_PROFILE_INFO = 'SUCCESS_UPDATE_PROFILE_INFO';
export var FAILURE_UPDATE_PROFILE_INFO = 'FAILURE_UPDATE_PROFILE_INFO';
export var CHECK_PHONE = 'CHECK_PHONE';
export var SUCCESS_CHECK_PHONE = 'SUCCESS_CHECK_PHONE';
export var FAILURE_CHECK_PHONE = 'FAILURE_CHECK_PHONE';
export var FETCH_GAMBLER = 'FETCH_GAMBLER';
export var SUCCESS_FETCH_GAMBLER = 'SUCCESS_FETCH_GAMBLER';
export var FAILURE_FETCH_GAMBLER = 'FAILURE_FETCH_GAMBLER';
export var CHANGE_PROFILE_PASSWORD = 'CHANGE_PROFILE_PASSWORD';
export var CHANGE_PROFILE_PASSWORD_SUCCESS = 'CHANGE_PROFILE_PASSWORD_SUCCESS';
export var CHANGE_PROFILE_PASSWORD_FAILURE = 'CHANGE_PROFILE_PASSWORD_FAILURE';
export var CLEAR_UPDATED_RESULT_PROFILE = 'CLEAR_UPDATED_RESULT_PROFILE';



// WEBPACK FOOTER //
// ./src/actions/profile/profile.js